import filterFieldsets from './helpers';
import { EXCLUDE_FIELDSETS_MAP, LEGAL_AGE_VALUE } from './constants';

const FIELDSETS = siteAbbr => [
  { type: 'email' },
  {
    type: 'personal-info',
    options: { dob_optional: true, diverse_gender_options: true }
  },
  { type: 'contact-info' },
  { type: 'education' },
  { type: 'cv' },
  { type: 'password' },
  {
    type: 'terms-agreement',
    options: {
      legal_age_checkbox: true,
      legal_age_value: LEGAL_AGE_VALUE[siteAbbr]
    }
  }
];

export default siteAbbr => ({
  pages: [
    {
      fieldsets: filterFieldsets(
        FIELDSETS(siteAbbr),
        EXCLUDE_FIELDSETS_MAP,
        siteAbbr
      ),
      sidebar: [{ type: 'usp' }, { type: 'contact' }]
    }
  ]
});
